<template>
  <div id="CreateClaimClaimInfo" class="bg-light pb-3">
    <div class="col">
      <p v-if="claimDto.ClaimType !== 'ExtraParts'" class="pl-3 py-4">
        Please review the following parts. Select the quantity you would like to return, the reason for the return, and
        any additional comments about the specific items.
      </p>
      <p v-if="claimDto.ClaimType === 'ExtraParts'" class="pl-3 py-4">
        Please review the following parts.
      </p>
      <div v-if="claimDto.ClaimType !== 'ExtraParts'" class="row no-gutters mx-3 mb-3 modify">
        <div class="row col-lg-3 col-med-3 col-sm-5 col-xs-6 pt-2 ml-3">
          <label
            id="ClaimReasonAllLabel"
            aria-label="Claim Reason for All Parts"
            aria-describedby="ClaimReasonAllLabel"
          >
            <div>Select Claim Reason For All:&nbsp;</div>
          </label>
        </div>
        <div class="mx-2 mt-1">
          <ToolTipPopOver
            :popover-message="claimReasonHtml"
            :popover-title="claimReasonPopoverTitle"
          />
        </div>
        <div class="col-lg-4 col-med-4 col-sm-6 col-xs-12">
          <b-form-select
            id="ClaimReasonAll"
            v-model="selectedClaimReasonAll"
            :options="claimReasonAll"
            name="Claim Reason All Parts"
          >
            <template slot="first">
              <option :value="null" disabled>
                Select
              </option>
            </template>
          </b-form-select>
        </div>
      </div>
      <div
        v-for="(part, index) in claimDto.Items"
        :key="index"
        class="row mx-3 p-3 mb-4 bg-white"
      >
        <!-- THUMBNAIL -->
        <div class="col col-lg-2 col-md-2 no-gutters pr-3">
          <div class="">
            <img class="create-claim__part-image" :src="part.ImageUrl">
          </div>
        </div>
        <div class="col col-lg-10 col-md-10 no-gutters p-0">
          <!-- PART INFORMATION -->
          <div class="row col-lg-12 col-mg-12 m-0">
            <div class="col-lg-3 col-md-3 col-sm-6 pl-0">
              <div class="">
                <label><strong>Part Number</strong></label>
              </div>
              <div class="">
                <PartDetailsLink :oem-part-code="part.OrderedOemPartCode" />
              </div>
              <div class="">
                {{ part.PartDescription }}
              </div>
            </div>

            <div class="row col-lg-9 col-md-9 col-sm-6 no-gutters">
              <!-- CLAIM QTY -->
              <div class="col-lg-5 col-md-5 col-sm-12 p-0">
                <div class="row">
                  <div>
                    <label>
                      <strong>Claim Quantity:</strong><span v-if="claimDto.ClaimType !== 'ExtraParts'" class="red-required"><big>*</big></span>
                    </label>
                  </div>
                  <div v-if="claimDto.ClaimType === 'ExtraParts'" class="" style="padding-left: 12px;">
                    {{ part.ReturnQuantity }}
                  </div>
                  <div class="mx-1">
                    <ToolTipPopOver
                      popover-message="Quantity you would like to submit for claim."
                      popover-title="Claim Quantity"
                    />
                  </div>
                </div>

                <div v-if="claimDto.ClaimType !== 'ExtraParts'" class="row">
                  <b-form-select
                    v-model="part.ReturnQuantity"
                    v-validate="{required: true, is_not: 0}"
                    class="form-control"
                    :options="PartQtySetup(part)"
                    :name="'ClaimQuantity' + index.toString()"
                    aria-describedby="claimQtyLiveFeedback"
                    :state="ValidateState('ClaimQuantity' + index.toString())"
                  >
                    <template slot="first">
                      <option :value="0" disabled>
                        Select
                      </option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="claimQtyLiveFeedback">
                    Claim Quantity is Required.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback />
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-12 p-0" />
              <!-- CLAIM REASON -->
              <div class="col-lg-5 col-md-5 col-sm-12 p-0">
                <div v-if="claimDto.ClaimType !== 'ExtraParts'" class="row">
                  <div>
                    <label>
                      <strong>Claim Reason:</strong><span v-if="claimDto.ClaimType !== 'ExtraParts'" class="red-required"><big>*</big></span>
                    </label>
                  </div>
                  <div class="mx-1">
                    <!-- if bound to variables fails in the loop of parts -->
                    <ToolTipPopOver
                      :popover-message="claimReasonHtml"
                      :popover-title="claimReasonPopoverTitle"
                    />
                  </div>
                </div>
                <div v-if="claimDto.ClaimType !== 'ExtraParts'" class="row">
                  <b-form-select
                    id="partClaimReason"
                    v-model="part.ClaimReason"
                    v-validate="{required: true, is_not: 'None'}"
                    class="form-control"
                    :options="claimReasonAll"
                    :name="'ClaimReason' + index.toString()"
                    aria-describedby="claimReasonLiveFeedback"
                    :state="ValidateState('ClaimReason' + index.toString())"
                  >
                    <template slot="first">
                      <option :value="'None'" disabled>
                        Select
                      </option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="claimReasonLiveFeedback">
                    Claim Reason is Required.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback />
                </div>
              </div>
              <div v-if="part.ClaimReason !== 'None'" class="row mt-1">
                <strong>Claim Reason:&nbsp;</strong>{{ getContentItem(part.ClaimReason) }}
              </div>
            </div>
          </div>
          <!-- COMMENTS -->
          <div class="row no-gutters mt-2">
            <label>
              <strong>Comments:</strong>
              <br v-if="claimDto.ClaimType == 'ExtraParts'">
              <em v-if="claimDto.ClaimType == 'ExtraParts'">Please enter tag information and comments. Also please indicate whether or not you would like to keep the parts.</em></label>
            <b-form-textarea
              v-model="part.Comments"
              v-validate="{required: true, min: partCommentMin, max: partCommentMax}"
              :name="'ClaimComments' + index.toString()"
              :state="ValidateState('ClaimComments' + index.toString())"
              rows="3"
              max-rows="7"
            />
            <b-form-invalid-feedback>
              Claim Comments are Required. Comment length must be between {{ partCommentMin }} and {{ partCommentMax }} characters.
            </b-form-invalid-feedback>
            <b-form-valid-feedback />
          </div>
        </div>   
      </div>
      <!-- Images upload link -->
      <div v-if="claimDto.ClaimType === 'PartsIssue'" id="uploadImagesLink">
        <h3> Upload Optional Images </h3>
        <br>
        <div 
          v-for="(image, index) in claimDto.ClaimImagesFilenames" 
          :key="image + index"
        >
          {{ image }}
        </div>
      </div>
    </div>
    <div
      :id="imagesUploadModalId"
      centered
      title-html="Upload Optional Images"
      ok-title="Done"
      size="lg"
      class="ccci__images-upload-input-wrapper"
      @cancel="ClearImages"
    >
      <file-upload-multiple
        v-if="claimDto.ClaimType === 'PartsIssue'"
        id="claim-images-file-upload"
        ref="fileUpload"
        :is-saving-images="isSavingImages"
        :all-images-saved="allImagesSaved"
        description="Multiple image files must be selected together before clicking 'Done'; additional files cannot be added later and will only override."
        @input-change-multi="ImagesChangeMulti"
      />
    </div>
  </div>
</template>


<script>
  import { mapGetters }         from "vuex"
  import ToolTipPopOver         from "@/components/Elements/ToolTipPopover"
  import { ClaimsService }      from "@/services/ClaimsService"
  import PartDetailsLink        from "@/components/Elements/PartDetailsLink"
  import { stringHelper }       from "@/components/mixins/stringHelper"
  import { inputValidateState } from "@/components/mixins/inputValidateState"
  import { claimReasonPopover } from "@/components/mixins/ClaimReasonPopover"
  import FileUploadMultiple     from "@/components/Elements/FileUploadMultiple"
  import { indexOf, reduce }    from "lodash"

  export default {
    components: {
      ToolTipPopOver,
      PartDetailsLink,
      FileUploadMultiple
    },

    mixins: [stringHelper, inputValidateState, claimReasonPopover],

    props: {
      claimDto: {
        type: Object,
        default: () => ({})
      },
      validationState: {
        type: Object,
        default: () => ({}),
        claimInfoTab: { type: Boolean, default: false }
      },
      imagesUploadModalId: {
        type: String,
        default: "imagesUploadModal"
      }
    },

    data: () => ({
      selectedClaimReasonAll: null,
      claimReasonAll: [],
      selectedClaimQuantity: null,
      claimReasonPopoverTitle: "Claim Reasons Defined",
      partCommentMin: 5,
      partCommentMax: 250,
      dispalyFileUpload: false,
      isSavingImages: false,
      allImagesSaved: false,
      addFilesToRequest: false
    }),
    computed: {
      ...mapGetters(["getContentItem"])
    },
    watch: {
      selectedClaimReasonAll: function (claimReasonForAll) {
        for (let i = 0; i < this.claimDto.Items.length; i++) {
          this.claimDto.Items[i].ClaimReason = claimReasonForAll
        }
      }
    },
    // Since there are several inputs to validate, using `updated` to loop through all
    // inputs to check valid state whenever the page changes.
    updated () {
      this.$validator.validateAll().then((result) => {
        this.validationState.claimInfoTab = result
      })
    },

    methods: {
      Setup () {
        ClaimsService.GetClaimReasons().then(claimReasonsList => {
          this.claimReasonAll = [];
          claimReasonsList.data.forEach(claimReason => {
            if( claimReason.value !== undefined && claimReason.value !== "None" ){
              claimReason.text = this.getContentItem(claimReason.value);
            }
            
            if(this.claimDto.ClaimType == "PartsIssue"){
              if(!["IncorrectFreightCharge","WrongFreightOrShipVia"].includes(claimReason.value))
              {
                this.claimReasonAll.push(claimReason)
              }
            }
            else{
              this.claimReasonAll.push(claimReason)
            }
          });
        })
      },
      PartQtySetup (currentPart) {
        // loop through each part's ordered quantity and set up the selection box
        // to have all quantities between 1 and the total ordered.
        let quantities = []
        for (let i = 1; i <= currentPart.OrderedQuantity; i++) {
          quantities.push({ value: i, text: i.toString() })
        }
        return quantities
      },
      ImagesChange: function () {  
        this.claimDto.ClaimImagesBase64 = this.$refs.fileUpload.fileBase64Strings;
        this.claimDto.ClaimImagesFilenames = this.$refs.fileUpload.fileNames;
      },
      ImagesChangeMulti: async function (files, totalFiles) {
        this.isSavingImages = true;
        var self = this;
        var allFileUrls = [];

        for (var fileToSave of files.values()) {
          let fileName = fileToSave.name;
          let fileType = fileToSave.type;
          let fileData = fileToSave;
          let base64;

          let self = this;

          let reader = new FileReader();
          reader.readAsDataURL(fileToSave);
          reader.onload = async function() {
            let indexOfComma = reader.result.indexOf(",") + 1;
            let imageFile = {
              ImageName: fileName,
              Base64String: reader.result.substring(indexOfComma, reader.result.length)
            }
            
            await ClaimsService.SaveClaimsMediaFile(imageFile)
              .then((response) => {
                if (response === "ERROR") {
                  self.$store.commit("pushTimedMessage", {
                    header: "Error uploading your file",
                    message: "Please try again. If this error continues contact support.",
                    IsError: true,
                    seconds: 30,
                  });
                } else {
                  allFileUrls.push(response);
                }
              })
              .finally(() => {
                if (allFileUrls.length === totalFiles) {
                  self.isSavingImages = false;
                  self.allImagesSaved = true;
                  self.addFilesToRequest = true;
                }
              });
          }
        }
        this.claimDto.ClaimImagesUrls = allFileUrls;
      },
      toggleFileUpload() {
        this.dispalyFileUpload = !this.dispalyFileUpload;
      },
      ClearImages: function () {    
        this.claimDto.ClaimImagesBase64 = [];
        this.claimDto.ClaimImagesFilenames = [];
        this.$refs.fileUpload.fileBase64Strings= [];
        this.$refs.fileUpload.fileNames = [];
      },
      BrowserIsIE(){
        return IsIE();
      },
    }
  }
</script>

<style lang="scss">
#claim-images-file-upload{
  #drop-zone{
    height: 400px;
    .image-upload-text{
      top: 25%;
      font-size: 32px;
    }
    .images-uploaded-text{
      bottom: 240px;
      white-space: nowrap;
      *{
          display: block;
          height: 0;
          font-size: 18px;
      }
    }
  }
  #fileUploadBrowseButton{
    margin-top: 12px;
  }

  .description{
    padding: 6px 80px;
  }
}

#uploadImagesLink{
    width: 100%;
    margin-top: 12px;
    text-align: center;
}


@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
     /* IE10+ CSS styles */
     .images-uploaded-text{
      transform: translate(126%);
    }

}

.ccci__images-upload-input-wrapper {
  text-align: center;
}

.create-claim__part-image{
  width: 100%;
}
</style>
